import { render, staticRenderFns } from "./ExplainBlock.vue?vue&type=template&id=575f2436&"
import script from "./ExplainBlock.vue?vue&type=script&lang=js&"
export * from "./ExplainBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports